// Telegram Haptic Feedback wrapper. Safe no-op outside Telegram WebApp
// (dev in browser, non-supporting clients) — never throws.
// Call these on pointerdown/click of tappable UI, or on semantic events.

type Impact = 'light' | 'medium' | 'heavy' | 'rigid' | 'soft'
type Notif = 'error' | 'success' | 'warning'

function tg() {
  if (typeof window === 'undefined') return undefined
  return window.Telegram?.WebApp?.HapticFeedback
}

export function hapticTap(style: Impact = 'light') {
  tg()?.impactOccurred?.(style)
}

export function hapticSelect() {
  tg()?.selectionChanged?.()
}

export function hapticNotify(type: Notif) {
  tg()?.notificationOccurred?.(type)
}
